import React from "react";
import HonariLogoIcon from "../../assets/images/honari_logo.png";
import HomeBlackIcon from "../../assets/images/home_black.png";
import BoxBlckIcon from "../../assets/images/box_black.png";
import DiscountBlackIcon from "../../assets/images/discount_black.png";
import BikeBlackIcon from "../../assets/images/motorbike_black.png";
import UserBlackIcon from "../../assets/images/user_black.png";
import coinsBlackIcon from "../../assets/images/coins_black.png";
import "./RightMenu.css";
import { Link } from "react-router-dom";

const RightMenu = () => {
    return (
        <div
            className={["container-fluid", "text-center"].join(" ")}
            style={{
                width: "300px",
                height: "100%",
                backgroundColor: "#21222d",
            }}
        >
            <img
                src={HonariLogoIcon}
                style={{ width: "80px" }}
                className={["mt-2", "mb-2"].join(" ")}
            />
            <div className="rightmenue_link">
                <Link to={"/admin/list"}>
                    <div
                        className={[
                            "row",
                            "d-flex",
                            "text-right",
                            "align-items-center",
                            "pt-2",
                            "pb-2",
                            "item",
                        ].join(" ")}
                        style={{ direction: "rtl" }}
                    >
                        <img
                            src={BoxBlckIcon}
                            style={{
                                width: "24px",
                                marginRight: "5px",
                                marginLeft: "5px",
                            }}
                        />
                        <h6 className={["m-0", "p-0"].join(" ")}>
                            مدیریت پرسش های متداول
                        </h6>
                    </div>
                </Link>
            </div>
            <div className="rightmenue_link">
                <Link to={"/admin/faq_cat"}>
                    <div
                        className={[
                            "row",
                            "d-flex",
                            "text-right",
                            "align-items-center",
                            "pt-2",
                            "pb-2",
                            "item",
                        ].join(" ")}
                        style={{ direction: "rtl" }}
                    >
                        <img
                            src={BoxBlckIcon}
                            style={{
                                width: "24px",
                                marginRight: "5px",
                                marginLeft: "5px",
                            }}
                        />
                        <h6 className={["m-0", "p-0"].join(" ")}>
                            مدیریت دسته های پرسش های متداول
                        </h6>
                    </div>
                </Link>
            </div>
            <div className="rightmenue_link">
                <Link to={"/admin/user_search"}>
                    <div
                        className={[
                            "row",
                            "d-flex",
                            "text-right",
                            "align-items-center",
                            "pt-2",
                            "pb-2",
                            "item",
                        ].join(" ")}
                        style={{ direction: "rtl" }}
                    >
                        <img
                            src={BoxBlckIcon}
                            style={{
                                width: "24px",
                                marginRight: "5px",
                                marginLeft: "5px",
                            }}
                        />
                        <h6 className={["m-0", "p-0"].join(" ")}>
                            جستجوی کاربران
                        </h6>
                    </div>
                </Link>
            </div>
            <div className="rightmenue_link">
                <Link to={"/admin/replace_url"}>
                    <div
                        className={[
                            "row",
                            "d-flex",
                            "text-right",
                            "align-items-center",
                            "pt-2",
                            "pb-2",
                            "item",
                        ].join(" ")}
                        style={{ direction: "rtl" }}
                    >
                        <img
                            src={BoxBlckIcon}
                            style={{
                                width: "24px",
                                marginRight: "5px",
                                marginLeft: "5px",
                            }}
                        />
                        <h6 className={["m-0", "p-0"].join(" ")}>
                            تغییر کلی آدرس
                        </h6>
                    </div>
                </Link>
            </div>
            <Link to={"/admin/cronjob/failed"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={HomeBlackIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>کرون جاب های ناموفق  </h6>
                </div>
            </Link>
            <Link to={"/admin/cronjob/success"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={HomeBlackIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>کرون جاب های موفق</h6>
                </div>
            </Link>
            <Link to={"/admin/shipping/index"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BikeBlackIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>حمل و نقل</h6>
                </div>
            </Link>
            <Link to={"/admin/user_reports"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BikeBlackIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>  گزارش عملکرد انبار  </h6>
                </div>
            </Link>
             <Link to={"/admin/task/time"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BikeBlackIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>  تغییر زمان فعالیت های انبار  </h6>
                </div>
            </Link>
            <div className="rightmenue_link">
                <Link to={"/admin/discount"}>
                    <div
                        className={[
                            "row",
                            "d-flex",
                            "text-right",
                            "align-items-center",
                            "pt-2",
                            "pb-2",
                            "item",
                        ].join(" ")}
                        style={{ direction: "rtl" }}
                    >
                        <img
                            src={BoxBlckIcon}
                            style={{
                                width: "24px",
                                marginRight: "5px",
                                marginLeft: "5px",
                            }}
                        />
                        <h6 className={["m-0", "p-0"].join(" ")}>تخفیف ها</h6>
                    </div>
                </Link>
            </div>
            <div className="rightmenue_link">
                <Link to={"/admin/rfm/setting"}>
                    <div
                        className={[
                            "row",
                            "d-flex",
                            "text-right",
                            "align-items-center",
                            "pt-2",
                            "pb-2",
                            "item",
                        ].join(" ")}
                        style={{ direction: "rtl" }}
                    >
                        <img
                            src={BoxBlckIcon}
                            style={{
                                width: "24px",
                                marginRight: "5px",
                                marginLeft: "5px",
                            }}
                        />
                        <h6 className={["m-0", "p-0"].join(" ")}>Rfm Setting </h6>
                    </div>
                </Link>
            </div>
             <div className="rightmenue_link">
                <Link to={"/admin/rfm"}>
                    <div
                        className={[
                            "row",
                            "d-flex",
                            "text-right",
                            "align-items-center",
                            "pt-2",
                            "pb-2",
                            "item",
                        ].join(" ")}
                        style={{ direction: "rtl" }}
                    >
                        <img
                            src={BoxBlckIcon}
                            style={{
                                width: "24px",
                                marginRight: "5px",
                                marginLeft: "5px",
                            }}
                        />
                        <h6 className={["m-0", "p-0"].join(" ")}>Rfm  </h6>
                    </div>
                </Link>
            </div>
            <Link to={"/admin/anbarGardani"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BoxBlckIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>انبارگردانی</h6>
                </div>
            </Link>

            <Link to={"/admin/faild_orders"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BoxBlckIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>
                        عملیات های ناموفق ثبت سفارش
                    </h6>
                </div>
            </Link>

            <Link to={"/admin/excel"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BoxBlckIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>گزارش</h6>
                </div>
            </Link>
            
            <Link to={"/admin/excel/index"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BoxBlckIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>خروجی گزارش</h6>
                </div>
            </Link>
             <Link to={"/admin/conflict/product"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BoxBlckIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>مغایرت های موجودی محصول</h6>
                </div>
            </Link>
            
             <Link to={"/admin/conflict/pack"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BoxBlckIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>مغایرت های موجودی بسته</h6>
                </div>
            </Link>

            <Link to={"/admin/convertible"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BoxBlckIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>بسته های قابل تبدیل</h6>
                </div>
            </Link>
            <Link to={"/admin/setting"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BoxBlckIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>تنظیمات</h6>
                </div>
            </Link>
            <Link to={"/admin/orders"}>
                <div
                    className={[
                        "row rightmenue_link",
                        "d-flex",
                        "text-right",
                        "align-items-center",
                        "pt-2",
                        "pb-2",
                        "item",
                    ].join(" ")}
                    style={{ direction: "rtl" }}
                >
                    <img
                        src={BoxBlckIcon}
                        style={{
                            width: "24px",
                            marginRight: "5px",
                            marginLeft: "5px",
                        }}
                    />
                    <h6 className={["m-0", "p-0"].join(" ")}>مدیریت سفارشات</h6>
                </div>
            </Link>
            <div className="rightmenue_link">
                <Link to={"/admin/banner"}>
                    <div
                        className={[
                            "row",
                            "d-flex",
                            "text-right",
                            "align-items-center",
                            "pt-2",
                            "pb-2",
                            "item",
                        ].join(" ")}
                        style={{ direction: "rtl" }}
                    >
                        <img
                            src={BoxBlckIcon}
                            style={{
                                width: "24px",
                                marginRight: "5px",
                                marginLeft: "5px",
                            }}
                        />
                        <h6 className={["m-0", "p-0"].join(" ")}>بنر ها</h6>
                    </div>
                </Link>
            </div>
        </div>
    );
};

export default RightMenu;
